import './Username.scss';

import React, { useState } from 'react';

import LanderChat from '../../LanderChat/LanderChat';
import Button from '../../UI/Button/Button';
import Input from '../../UI/Input/Input';

export default function Username({ setValue, errors, clearErrors, handleNextStep }) {
  const [isElementVisible, setIsElementVisible] = useState(false);

  const messages = [{ content: 'Please create a username' }];

  const toggleElementVisibility = () => {
    setIsElementVisible(!isElementVisible);
  };

  return (
    <>
      <LanderChat messages={messages} endChatAction={toggleElementVisibility} />

      <div className={isElementVisible ? 'ToggleElement' : 'Hidden'}>
        <div className="InputsContainer">
          <Input
            placeholder="Username"
            name="username"
            {...{
              errors,
              setValue,
              clearErrors
            }}
          />
        </div>
        <div className="ButtonsContianer">
          <Button text="NEXT" handleNextStep={() => handleNextStep(['username'])} />
        </div>
      </div>
    </>
  );
}
